export const FAQ = [
    {
        header: 'What is AdvisorFinder?',
        link: 'https://www.advisorfinder.com/faq-for-consumers#1',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    },
    {
        header: 'How are advisors approved to be on AdvisorFinder?',
        link: 'https://www.advisorfinder.com/faq-for-consumers#2',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    },
    {
        header: 'What happens to my information?',
        link: 'https://www.advisorfinder.com/faq-for-consumers#3',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    },
    {
        header: 'What happens if I\'m not happy with the advisor I met with?',
        link: 'https://www.advisorfinder.com/faq-for-consumers#4',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    },
];

export const KnowledgeBase = [
    {
        header: 'Why should I work with an advisor?',
        link: 'https://www.advisorfinder.com/blog-posts/value-of-working-with-an-advisor',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    },
    {
        header: 'What services do financial advisors provide?',
        link: 'https://www.advisorfinder.com/blog-posts/services-provided-by-financial-advisors',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    },
    {
        header: 'Best Questions to Ask Your Advisor',
        link: 'https://www.advisorfinder.com/blog-posts/10-best-questions-to-ask-your-financial-advisor',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    },
    {
        header: 'How are financial advisors paid?',
        link: 'https://www.advisorfinder.io/blog-posts/how-expensive-is-a-financial-advisor',
        content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.'
    },
];